import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, Spinner } from "@chakra-ui/react";
import React from "react";
import { useDebouncedSave } from "../useDebouncedSave";

interface Props {
  label: string;
  name: string;
  helperText: string;
  errorMessage: string | undefined;
  onChange: (value: string) => void;
  debouncedOnChangeHandler?: (value: string) => Promise<void>;
  value: string;
  isLoading: boolean;
  type?: React.HTMLInputTypeAttribute | undefined;
  isRequiredButNotProvided?: boolean;
}

export const SimpleInput = ({
  name,
  label,
  onChange,
  helperText,
  errorMessage,
  value,
  isLoading,
  type,
  debouncedOnChangeHandler,
  isRequiredButNotProvided,
}: Props) => {
  const debouncedSave = useDebouncedSave(async (value: string) => {
    if (debouncedOnChangeHandler) await debouncedOnChangeHandler(value);
  });

  return (
    <FormControl isRequired={isRequiredButNotProvided} isInvalid={errorMessage !== undefined}>
      <FormLabel htmlFor={name}>
        {label} {isLoading && <Spinner size="xs" />}
      </FormLabel>
      <Input
        id={name}
        type={type ?? "text"}
        onChange={(e) => {
          onChange(e.target.value);
          debouncedSave(e.target.value);
        }}
        value={value === undefined ? "" : value}
      />
      <FormHelperText>{helperText}</FormHelperText>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};
